/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u3m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steeping black tea, which typically needs 3 to 5 minutes for full flavor.`)
};

const es_timer_u3m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejar en infusión té negro, que normalmente necesita de 3 a 5 minutos para su sabor completo.`)
};

const de_timer_u3m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwarzen Tee ziehen lassen, der für volles Aroma typischerweise 3 bis 5 Minuten braucht.`)
};

const nl_timer_u3m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwarte thee laten trekken, wat meestal 3 tot 5 minuten nodig heeft voor volle smaak.`)
};

const fr_timer_u3m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infuser du thé noir, qui nécessite généralement 3 à 5 minutes pour développer tout son arôme.`)
};

const it_timer_u3m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lasciare in infusione il tè nero, che di solito richiede da 3 a 5 minuti per il pieno sapore.`)
};

const pt_br2_timer_u3m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fazer a infusão de chá preto, que geralmente precisa de 3 a 5 minutos para o sabor completo.`)
};

const pt_timer_u3m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixar o chá preto em infusão, o que normalmente precisa de 3 a 5 minutos para o sabor completo.`)
};

const ja_timer_u3m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`十分な風味を引き出すために通常3〜5分かかる紅茶を浸出させる。`)
};

const zh_timer_u3m_use2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冲泡红茶，通常需要3到5分钟才能释放完整风味。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u3m_use2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u3m_use2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u3m_use2", locale)
	if (locale === "en") return en_timer_u3m_use2(inputs)
	if (locale === "es") return es_timer_u3m_use2(inputs)
	if (locale === "de") return de_timer_u3m_use2(inputs)
	if (locale === "nl") return nl_timer_u3m_use2(inputs)
	if (locale === "fr") return fr_timer_u3m_use2(inputs)
	if (locale === "it") return it_timer_u3m_use2(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u3m_use2(inputs)
	if (locale === "pt") return pt_timer_u3m_use2(inputs)
	if (locale === "ja") return ja_timer_u3m_use2(inputs)
	return zh_timer_u3m_use2(inputs)
};